import { useTranslation } from 'react-i18next';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyMuiButton } from '~/legacy-components/LegacyForms';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { HomeContactEditMode } from './components/HomeContactEditMode';
import { HomeContactReadMode } from './components/HomeContactReadMode';
import { useHomeContract } from './useHomeContact';

export const HomeContact = () => {
  const {
    empData,
    register,
    errors,
    onSubmit,
    readMode,
    setReadMode,
    countriesList,
    handleDelete,
    control,
    handleFormReset,
    isLoading,
  } = useHomeContract();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <LegacyHeadingWithActions heading={t('laHomeContact')}>
        {!readMode ? (
          <>
            <LegacyMuiButton
              onClick={handleDelete}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Delete} />}
            >
              {t('laClear')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={onSubmit}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Save} />}
            >
              {t('laSave')}
            </LegacyMuiButton>
            <LegacyMuiButton
              onClick={() => handleFormReset(false)}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Close} />}
            >
              {t('laCancel')}
            </LegacyMuiButton>
          </>
        ) : (
          <>
            <LegacyMuiButton
              onClick={() => setReadMode(false)}
              startIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Edit} />}
            >
              {t('laEdit')}
            </LegacyMuiButton>
          </>
        )}
      </LegacyHeadingWithActions>
      {readMode ? (
        <HomeContactReadMode data={empData} countryList={countriesList} />
      ) : (
        <HomeContactEditMode
          data={empData}
          register={register}
          errors={errors}
          countryList={countriesList}
          control={control}
        />
      )}
    </>
  );
};
